import { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AuthContext = createContext(null);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within AuthProvider");
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  // Utilisateur par défaut - bypass authentification
  const [user, setUser] = useState({
    id: "default-admin",
    email: "admin@e-secure.ch",
    name: "Administrateur",
    role: "admin",
    created_at: new Date().toISOString()
  });
  const [token, setToken] = useState("bypass-token");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // Set default auth header for API calls
    axios.defaults.headers.common["Authorization"] = "Bearer bypass";
  }, []);

  const login = async (email, password) => {
    // Bypass - pas de vérification
    return user;
  };

  const register = async (email, password, name) => {
    return user;
  };

  const logout = () => {
    // Ne fait rien - toujours connecté
  };

  return (
    <AuthContext.Provider value={{ user, token, loading, login, register, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
